import AddEvents from './AddEvents'

export default AddEvents
